// User types
export interface User {
  id: string;
  username: string;
  displayName: string;
  email?: string;
  profileImageUrl?: string;
  broadcasterType: 'partner' | 'affiliate' | '';
  role: UserRole;
  createdAt: string;
  lastLoginAt: string;
}

export type UserRole = 'default' | 'premium';

export interface UserSession {
  userId: string;
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
  role: UserRole;
}

// VOD types
export interface VOD {
  id: string;
  userId: string;
  twitchVodId?: string;
  title: string;
  description?: string;
  filename: string;
  originalFilename?: string;
  fileSize: number;
  duration?: number;
  thumbnailUrl?: string;
  previewUrl?: string;
  uploadedAt: string;
  streamedAt?: string;
  tags: string[];
  isLongTerm: boolean;
  source: 'manual' | 'twitch';
  status: VODStatus;
  chatBackupSize?: number;
}

export type VODStatus = 'uploading' | 'processing' | 'ready' | 'error';

export interface TwitchVOD {
  id: string;
  stream_id: string;
  user_id: string;
  user_login: string;
  user_name: string;
  title: string;
  description: string;
  created_at: string;
  published_at: string;
  url: string;
  thumbnail_url: string;
  viewable: string;
  view_count: number;
  language: string;
  type: string;
  duration: string;
}

// Upload types
export interface UploadRequest {
  filename: string;
  fileSize: number;
  contentType: string;
}

export interface UploadResponse {
  uploadId: string;
  uploadUrl: string;
  vodId: string;
}

// Dashboard types
export interface DashboardStats {
  totalVideos: number;
  totalStorageUsed: number;
  totalVodsDownloaded: number;
  dataInBytes: number;
  dataOutBytes: number;
  retentionPeriodDays: number;
  role: UserRole;
}

// API Response types
export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}

// Configuration types
export interface AppConfig {
  maxFileSize: number;
  allowedFileTypes: string[];
  retentionPeriods: {
    default: number;
    premium: number;
  };
  longTermThresholdDays: number;
  syncIntervalHours: number;
}

// Error types
export class AppError extends Error {
  constructor(
    message: string,
    public statusCode: number = 500,
    public code?: string
  ) {
    super(message);
    this.name = 'AppError';
  }
}

// Utility types
export interface KVMetadata {
  createdAt: string;
  updatedAt: string;
  expiresAt?: string;
}

export interface R2ObjectMetadata {
  userId: string;
  vodId: string;
  originalFilename: string;
  uploadedAt: string;
  isLongTerm?: boolean;
  contentType: string;
}